import CalendarViewRouteType from '../schema/CalendarViewRouteType';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';

export function getCalendarViewRouteFromType(
    viewType: CalendarViewTypeEnum
): CalendarViewRouteType {
    switch (viewType) {
        case CalendarViewTypeEnum.Daily:
            return 'day';
        case CalendarViewTypeEnum.Weekly:
            return 'week';
        case CalendarViewTypeEnum.WorkWeek:
            return 'workweek';
        case CalendarViewTypeEnum.Monthly:
            return 'month';
        case CalendarViewTypeEnum.Board:
            return 'board';
        default:
            return '';
    }
}
